module.exports = __webpack_public_path__ + "media/images/icon-benefits-birthday-fb21ad7907261390cca3a657a865bf34.png";